<template>
	<div class="mainApp">
		<DealsPage ref="deals_page" />
	</div>
</template>

<script>
import DealsPage from "@/components/DealsPage.vue";

export default {
	name: "StreetsBuyView",
	components: {
		DealsPage,
	},
	data() {
		return {
		};
	},
	mounted() {
		var appVue = this;
		if (appVue.$store.state.config == null) {
			appVue.$store.dispatch("loadConfig");
		}
		
		if (appVue.$store.state.neigh == null) {
			appVue.$store.dispatch("loadNeigh");
		}
		this.$store.state.searchType = "STREET";
		appVue.$store.state.streetCode = this.$route.query.id;
		appVue.$store.state.deals = [];
		this.mixin_fetchPageData(this, "STREET", this.$route.query.id, this.$store.state.config.api_base).then(() => {
			if (appVue.$store.state.setlCode != null) {

				var d_url = null;
				if (appVue.$store.state.neighborhoodId != null && appVue.$store.state.neighborhoodId != 0) {
					//https://d1pbgh6hzbn1h3.cloudfront.net/backgroundMaps/pages/neighborhood/buy/65209994.json
					d_url =
						appVue.$store.state.config.s3_page_base +
						"/neighborhood/buy/" +
						appVue.$store.state.neighborhoodId +
						".json";
				} else if (appVue.setlCode != null) {
					d_url =
						appVue.$store.state.config.s3_page_base +
						"/settlement/buy/" +
						appVue.setlCode +
						".json";
				} else {
					appVue.$router.push({ name: "notfound" });	
				}
				if (d_url != null) {
					fetch(d_url).then(function (response) {
						if (!response.ok) {
							appVue.$router.push({
								name: "notfound",
								query: { view: "notfound" },
							});
						}
						const data = response.json();
						data.then(function (e) {
							//set store neighborhood, setlName
							if (appVue.$store.state.neighborhoodName == null) {
								appVue.$store.state.neighborhoodName = e.neighborhoodName;
							}
							if (appVue.$store.state.settlementName == null) {
								appVue.$store.state.settlementName = e.settlementName;
							}
							appVue.$store.state.isMain = false;
							appVue.mixin_setTrendsData(appVue, e);
						});
					});
				}
			} 
			else {
				appVue.$store.state.loading = false;
				if (appVue.$route.name != "notfound") {
					appVue.$router.push({ name: "notfound" });
					return;
				}
				return;
				
			}
		});
	},
};
</script>
